/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable react-hooks/exhaustive-deps */
import React from "react";
import Swal from "sweetalert2";

import { useSelector } from "react-redux";

import { selectUser } from "reducers/userReducer";

import { THS_API_PIS } from "../../constants";

import "./index.css";
export default function Profile() {
  const user = useSelector(selectUser);

  const [data, setData] = React.useState<any>({});
  React.useEffect(() => {
    const callAPI = async () => {
      if (user.id) {
        Swal.showLoading();
        const res = THS_API_PIS.get(
          `${process.env.REACT_APP_API_ALL_ORG_UNITS}`,
          {
            params: {
              SearchUnit: user.searchUnit,
            },
          }
        );
        const res2 = THS_API_PIS.get(
          `${process.env.REACT_APP_API_SEARCH_DIRECTORY_INFO_NO_JOB_GROUP}`,
          {
            params: {
              EmployeeID: user.employeeId,
              DepartmentCode: user.searchUnit,
            },
          }
        );

        const [orgunits, searchDirectory] = await Promise.all([res, res2]);

        const orgunitsInfo = orgunits.data.entries.entry?.filter(
          (obj: any) => obj.UNITCODE === user.searchUnit
        );

        setData({
          ...orgunitsInfo[0],
          ...searchDirectory.data.entries.entry[0],
        });
        Swal.close();
      }
    };
    callAPI();
  }, [user.id]);
  return (
    <section className="profile">
      <div>
        <div className="header-topic">
          <h1>Profile Information</h1>
        </div>
        <div className="card-body search-bar">
          <div className="container top">
            <div className="row">
              <div className="col col-sm-6">{`${data.EmployeeId || ""} : ${
                data.EmployeeNameENG || ""
              }`}</div>
              <div className="col col-sm-6">
                <div
                  className="btn btn-back"
                  onClick={() => {
                    window.history.back();
                  }}
                >
                  Back
                </div>
              </div>
            </div>
          </div>
          <div className="container table">
            <div className="row">
              <div className="col col-sm-4 label">Business Unit Name</div>
              <div className="col col-sm-8">{data.BUSINESS_UNIT_NAME}</div>
            </div>
            <div className="row">
              <div className="col col-sm-4 label">Unit Level Name</div>
              <div className="col col-sm-8">{data.UNIT_LEVEL_NAME}</div>
            </div>
            <div className="row">
              <div className="col col-sm-4 label">Unit Code</div>
              <div className="col col-sm-8">{data.UNITCODE}</div>
            </div>
            <div className="row">
              <div className="col col-sm-4 label">Unit Name</div>
              <div className="col col-sm-8">{data.UnitName}</div>
            </div>
            <div className="row">
              <div className="col col-sm-4 label">Long Name</div>
              <div className="col col-sm-8">{data.LONGNAME}</div>
            </div>
            <div className="row">
              <div className="col col-sm-4 label">Unit ABBR</div>
              <div className="col col-sm-8">{data.UNITABBR}</div>
            </div>
            <div className="row">
              <div className="col col-sm-4 label">Eng Name</div>
              <div className="col col-sm-8">{data.ENGNAME}</div>
            </div>
            <div className="row">
              <div className="col col-sm-4 label">Employee Name ENG</div>
              <div className="col col-sm-8">{data.EmployeeNameENG}</div>
            </div>
            <div className="row">
              <div className="col col-sm-4 label">Employee Name TH</div>
              <div className="col col-sm-8">{data.EmployeeNameTH}</div>
            </div>
            <div className="row">
              <div className="col col-sm-4 label">Employee ID</div>
              <div className="col col-sm-8">{data.EmployeeId}</div>
            </div>
            <div className="row">
              <div className="col col-sm-4 label">Position Code</div>
              <div className="col col-sm-8">{data.PositionCode}</div>
            </div>
            <div className="row">
              <div className="col col-sm-4 label">Department Code</div>
              <div className="col col-sm-8">{data.DepartmentCode}</div>
            </div>
            <div className="row">
              <div className="col col-sm-4 label">Cost Center</div>
              <div className="col col-sm-8">{data.CostCenter}</div>
            </div>
            <div className="row">
              <div className="col col-sm-4 label">Department Name ENG</div>
              <div className="col col-sm-8">{data.DepartmentNameENG}</div>
            </div>
            <div className="row">
              <div className="col col-sm-4 label">Department Name TH</div>
              <div className="col col-sm-8">{data.DepartmentNameTH}</div>
            </div>
            <div className="row">
              <div className="col col-sm-4 label">Position Name ENG</div>
              <div className="col col-sm-8">{data.PositionNameENG}</div>
            </div>
            <div className="row">
              <div className="col col-sm-4 label">Position Name TH</div>
              <div className="col col-sm-8">{data.PositionNameTH}</div>
            </div>
            <div className="row">
              <div className="col col-sm-4 label">Position ABBR</div>
              <div className="col col-sm-8">{data.PositionABBR}</div>
            </div>
            <div className="row">
              <div className="col col-sm-4 label">Management Flag</div>
              <div className="col col-sm-8">{data.ManagementFlag}</div>
            </div>
            <div className="row">
              <div className="col col-sm-4 label">Department ABBR</div>
              <div className="col col-sm-8">{data.DepartmentABBR}</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
